module.exports = __webpack_public_path__ + "static/img/hwaq_banner.d0a78ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hwaq_banner.png
// module id = DKXW
// module chunks = 21